import {getSetting} from '../../spine-appkit-vue/src/utils/settings';

class CmsRouter {
    constructor() {
        this.getRoutesPrepend = this.getRoutesPrepend.bind(this);
        this.getRoutesAppend = this.getRoutesAppend.bind(this);
        this.getDashboardEditorChildren = this.getDashboardEditorChildren.bind(this);
        this.setRoutes = this.setRoutes.bind(this);
        this.beforeEachAuthChecks = this.beforeEachAuthChecks.bind(this);
        this.beforeEach2faChecks = this.beforeEach2faChecks.bind(this);
        this.setActiveRouter = this.setActiveRouter.bind(this);
    }

    /**
     * Get all the cms routes we need to prepend
     * @returns Array
     */
    getRoutesPrepend() {
        return [
            {
                path: '/',
                name: 'Dashboard',
                component: {
                    template: '<cms-dashboard/>'
                },
                meta: {
                    title: "Dashboard"
                },
            },
            {
                path: '/home',
                name: 'dashboard-home',
                component: {
                    template: '<cms-dashboard/>'
                },
                meta: {
                    title: "Dashboard"
                },
            },
            {
                path: '/login',
                name: 'login',
                component: {
                    template: '<cms-login-form/>'
                },
                meta: {
                    title: "Login"
                },
            },
            {
                path: '/password-recovery',
                name: 'password-recovery',
                component: {
                    template: '<cms-password-recovery-form/>'
                },
                meta: {
                    title: "Recovery"
                },
            },
            {
                path: '/password-reset',
                name: 'password-reset',
                component: {
                    template: '<cms-password-reset-form/>'
                },
                meta: {
                    title: "Reset"
                },
            },
            {
                path: '/password-reset-expired',
                name: 'password-reset-expired',
                component: {
                    template: '<cms-password-reset-expired/>'
                },
                meta: {
                    title: "Reset Expired"
                },
            },
            {
                path: '/profile',
                name: 'profile',
                component: {
                    template: '<cms-profile/>'
                },
                meta: {
                    title: "Profile"
                },
            },
            {
                path: '/dashboard-editor/default',
                name: 'dashboard-editor-default',
                component: {
                    template: '<cms-dashboard-editor/>'
                },
                children: this.getDashboardEditorChildren('dashboard-widget-form-default'),
                meta: {
                    title: "Dashboard Editor",
                    dashboardOwnerType: 'default',
                },
            },
            {
                path: '/dashboard-editor/user/:ownerId',
                name: 'dashboard-editor-user',
                component: {
                    template: '<cms-dashboard-editor/>'
                },
                children: this.getDashboardEditorChildren('dashboard-widget-form-user'),
                meta: {
                    title: "Dashboard Editor",
                    dashboardOwnerType: 'user',
                },
            },
            {
                path: '/dashboard-editor/role/:ownerId',
                name: 'dashboard-editor-role',
                component: {
                    template: '<cms-dashboard-editor/>'
                },
                children: this.getDashboardEditorChildren('dashboard-widget-form-role'),
                meta: {
                    title: "Dashboard Editor",
                    dashboardOwnerType: 'role',
                },
            },
            {
                path: '/dashboard-editor',
                name: 'dashboard-editor',
                component: {
                    template: '<cms-dashboard-editor/>'
                },
                children: this.getDashboardEditorChildren('dashboard-widget-form'),
                meta: {
                    title: "Dashboard Editor",
                    dashboardOwnerType: 'default',
                },
            },
        ]
    }

    getDashboardEditorChildren(routeName) {
        return [
            {
                path: ':widgetType/:referenceId/:hashId?/:relationString?',
                name: routeName,
                meta: {
                    title: "Dashboard widget form",
                },
                props: true,
                components: {
                    childView:  {
                        props: ['dataProvider'],
                        template: '<cms-dashboard-settings-form :dataProvider="dataProvider" v-on="$listeners"/>'
                    }
                },
            },
        ];
    }

    /**
     * Get all the cms routes we need to append
     * @returns Array
     */
    getRoutesAppend() {
        return [
            ...Vue.blueprintRoutes,
            {
                path: '/list/:listDefinition/:bundle',
                name: 'list',
                component: {
                    template: '<cms-list/>',
                },
                meta: {
                    title: "List"
                },
                children: [
                    {
                        path: 'media-inspector/:mediaId/:relationString?',
                        name: 'media-inspector',
                        components:{
                            childview: {
                                template: '<ak-stacked-window class="ak-dark" :showClose="false" @close="$router.back()"><cms-media-inspector v-on="$listeners" :mediaId="$route.params.mediaId" :relationString="$route.params.relationString" @close="$router.back()"/></ak-stacked-window>',
                            }
                        },
                    },
                    {
                        path: ':definition/:objectId/:relationString?',
                        name: 'list-form',
                        components:{
                            childview: {
                                template: '<cms-form v-on="$listeners"/>',
                            }
                        },
                    }
                ]
            },
            {
                path: '/import/:importDefinition/:bundle',
                name: 'import',
                component: {
                    template: '<cms-import/>'
                },
                meta: {
                    title: "Import"
                }
            },
            {
                path: '/history/:bundle/:objectId',
                name: 'history',
                component: {
                    template: '<cms-history/>',
                },
                meta: {
                    title: "History"
                },
            },
            {
                path: '/:gridDefinition/:bundle',
                name: 'grid',
                component: {
                    template: '<cms-grid/>'
                },
                meta: {
                    title: "Grid"
                },
                children: [
                    {
                        path: 'entry-detail/:objectId',
                        name: 'inbox-detail',
                        components: {
                            childview: {
                                template: '<cms-inbox-detail :key="$route.params.objectId" :objectId="$route.params.objectId" />'
                            }
                        }
                    },
                    {
                        path: ':definition/:objectId/:relationString?',
                        name: 'form',
                        components:{
                            childview: {
                                template: '<cms-form v-on="$listeners"/>',
                            }
                        },
                    }
                ]
            },
            {
                path: "/*",
                component: {
                    template: '<cms-page-not-found/>',
                }
            }
        ]
    }

    /**
     * Set Routes
     * We will set the workspace prefix for all the authenticated routes
     * And we will add the routes for the cms packe
     * @param routes
     * @returns {*[]}
     */
    setRoutes(routes) {
        // now we add the routes where we don't need authentication
        return [...this.getRoutesPrepend(), ...routes, ...this.getRoutesAppend()];
    }

    /**
     * Check if we need to be authenticated for some routes
     * @param to
     * @param from
     * @param next
     * @returns {Promise<void>}
     */
    async beforeEachAuthChecks(to, from, next) {
        const authRoutes = ['login','password-reset','password-recovery','password-reset-expired'];
        // Do the auth call to check if we are already logged in
        const isAuthenticated = await this.router.app.$authService.getIsAuthenticated();

        // if not authenticated and the route is a route where authentication is needed we redirect to login
        if (!authRoutes.includes(to.name) && !isAuthenticated) {
            next({name: 'login'});
        }

        // if authenticated and the route isen't a route where authentication is needed we redirect to home
        if (authRoutes.includes(to.name) && isAuthenticated) {
            // redirect to the home page
            next({path: '/'});
        }
        next();
    }

    /**
     * Check if 2fa is mandatory
     *
     * @param to
     * @param from
     * @param next
     * @returns {Promise<void>}
     */
    async beforeEach2faChecks(to, from, next) {
        const isAuthenticated = await this.router.app.$authService.getIsAuthenticated();
        if ( ! isAuthenticated) {
            return next();
        }

        const isMandatory = getSetting('auth.2FAMandatory') !== null ? getSetting('auth.2FAMandatory') : true;
        const user = this.router.app.$authService.getAuthUser();
        if ( ! isMandatory || user.is2faEnabled) {
            return next();
        }

        if (to.path.includes('/grid/cms-user/2fa') || to.path.includes('/grid/cms-user/enable-2fa')) {
            return next();
        }

        return next({
            name: 'form',
            params: {
                bundle: 'cms-user',
                definition: '2fa',
                gridDefinition: 'grid',
                objectId: user.id,
            }
        })
    }

    /**
     * Set the active router, so we can manipulate the beforeEach behavior
     * @param router
     */
    setActiveRouter(router) {
        this.router = router;

        // set some check for each route
        this.router.beforeEach(this.beforeEachAuthChecks);
        this.router.beforeEach(this.beforeEach2faChecks);
    }
}

Vue.cmsRouter = (new CmsRouter());
